import request from '@utils/request';
import url from '@utils/url';

const { HOST } = url;

export async function getAccoutListData(data) {
    const url = `${HOST}/cps-gateway/api/v1/account/manage`;
    return request({ method: 'get', url: url }, data);
}

/**
 * @func 获取所有渠道-即将废弃
 */
export async function getAllChannel() {
    const url = `${HOST}/cps-gateway/api/v1/channel/group/tree`;

    return request({ method: 'get', url: url, noLoading: true });
}

export async function getChannelByLvl(lvl, parentLvlId) {
    const url = `${HOST}/cps-gateway/api/v1/channel/group/tree/new`
    let params = { level: lvl }
    if (lvl === 2) {
        params.firstChannelId = parentLvlId
    }
    else if (lvl === 3) {
        params.secondChannelId = parentLvlId
    }

    return request({ method: 'get', url, noLoading: true }, params)
}


export async function createSumit(data) {
    const url = `${HOST}/cps-gateway/api/v1/account/manage/add`;

    return request({ method: 'post', url: url }, data);
}

export async function editSumit(data) {
    const url = `${HOST}/cps-gateway/api/v1/account/manage/update`;

    return request({ method: 'post', url: url }, data);
}

export async function getRoles() {
    const url = `${HOST}/cps-gateway/api/v1/account/roles`;

    return request({ method: 'get', url: url });
}

export async function deleteData(data) {
    const url = `${HOST}/cps-gateway/api/v1/account/manage/del`;

    return request({ method: 'post', url: url }, data);
}